module.exports = __webpack_public_path__ + "static/media/icon-todo-call.c131d8c6.svg";